import loadable from '@loadable/component';

export const SurchargePerGuestLoadable = loadable(() => import('./SurchargePerGuest'), {
  fallback: undefined,
  ssr: false,
});
